import { render, staticRenderFns } from "./nutritionMainpageFAB.vue?vue&type=template&id=31cce3a0"
import script from "./nutritionMainpageFAB.vue?vue&type=script&lang=js"
export * from "./nutritionMainpageFAB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports